module.exports = __webpack_public_path__ + "img/modal-document-create-success.e23a900d.svg";